import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { downgradeInjectable } from "@angular/upgrade/static";
import * as angular from "angular";
import { AddressValidatorsService } from "./address-validators.service";
import { AuthServiceProvider } from "./ajs-auth.service";
import { ClienteResourceProvider } from "./ajs-cliente-resource.service";
import { EncomendaServiceProvider } from "./ajs-encomenda.service";
import { IntegrationServiceProvider } from "./ajs-integration.service";
import { PedidoServiceProvider } from "./ajs-pedido.service";
import { PerfilServiceProvider } from "./ajs-perfil.service";
import { UiRouterStateProvider } from "./ajs-router-state.service";
import { RouteTransitionsServiceProvider } from "./ajs-router-transitions.service";
import { StateParamsServiceProvider } from "./ajs-state-params.service";
import { IntegrationApiService } from "./api/integration-api.service";
import { ProfileAddressApiService } from "./api/profile-address.service";
import { ReturnPackageApiService } from "./api/return-package.service";
import { ChartsService } from "./charts.service";
import { CustomerService } from "./customer.service";
import { LocalStorageServiceProvider } from "./localstorage.service";
import { OrderService } from "./order.service";
import { ProfileContactsService } from "./profile/profile-contacts.service";
import { OccurrenceApiService } from "./api/occurrence-api.service";
import { TicketApiService } from "./api/ticket-api.service";
import { FinancialApiService } from "./financial.service";
import { ComunicadosService } from "./api/comunicados.service";
import { ClienteApiService } from "./cliente.service";

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [
    ClienteApiService,
    ChartsService,
    CustomerService,
    OrderService,
    OccurrenceApiService,
    TicketApiService,
    IntegrationApiService,
    ReturnPackageApiService,
    ProfileAddressApiService,
    AddressValidatorsService,
    FinancialApiService,

    // Angular JS services
    AuthServiceProvider,
    ClienteResourceProvider,
    EncomendaServiceProvider,
    IntegrationServiceProvider,
    LocalStorageServiceProvider,
    PedidoServiceProvider,
    PerfilServiceProvider,
    ComunicadosService,
    StateParamsServiceProvider,
    UiRouterStateProvider,
    RouteTransitionsServiceProvider,
  ],
})
export class ServicesModule {}

try {
  angular
    .module("mandaeApp")
    .factory("$profileContacts", downgradeInjectable(ProfileContactsService));
} catch (e) {}
